import { motion } from "framer-motion";
import { SITE } from "../../data/site";
import { useT } from "@/i18n/I18nContext";

export default function AboutCreator() {
  const { t } = useT();
  const paragraphs = t("about.paragraphs");

  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="tt-section relative"
      style={{ background: "var(--tt-surface)" }}
    >
      <div className="mx-auto max-w-[1480px] px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="lg:col-span-5"
        >
          <div className="relative aspect-[4/5] overflow-hidden rounded-sm">
            <img
              src="https://customer-assets.emergentagent.com/job_brand-portfolio-41/artifacts/btopeco7_image-gen%20%2833%29.jpg"
              alt={SITE.founderName}
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <p className="tt-overline text-[var(--tt-gold)]">{t("about.role_overline")}</p>
              <p className="mt-2 font-serif text-2xl md:text-3xl text-white">
                {SITE.founderName}
              </p>
              <p className="text-[var(--tt-text-dim)] text-sm font-light">{SITE.founderRole}</p>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="lg:col-span-7"
        >
          <p className="tt-overline">{t("about.overline")}</p>
          <h2 className="mt-4 font-serif text-4xl md:text-6xl leading-[1.02] text-[var(--tt-text)]">
            {t("about.heading_1")}{" "}
            <em className="italic text-[var(--tt-gold)]">{t("about.heading_2")}</em>.
          </h2>
          <div className="mt-8 space-y-6 text-[var(--tt-text-dim)] font-light leading-relaxed text-base md:text-lg max-w-2xl">
            {paragraphs.map((parts, i) => {
              const [pre, channelLabel, post] = parts;
              const isAldeia = channelLabel.toLowerCase().includes("aldeia");
              return (
                <p key={i}>
                  {pre}
                  {channelLabel && (
                    <span style={{ color: isAldeia ? "var(--tt-aldeia)" : "var(--tt-trilhos)" }}>
                      {channelLabel}
                    </span>
                  )}
                  {post}
                </p>
              );
            })}
          </div>

          <div className="mt-12 max-w-xl">
            <p className="tt-overline mb-5">{t("about.metrics_label")}</p>
            <dl className="grid grid-cols-3 gap-6 border-t border-[var(--tt-border)] pt-8">
              <div>
                <dd className="font-serif text-3xl text-[var(--tt-text)]">+160</dd>
                <dt className="tt-overline mt-2">{t("about.metrics.videos")}</dt>
              </div>
              <div>
                <dd className="font-serif text-3xl text-[var(--tt-text)]">15</dd>
                <dt className="tt-overline mt-2">{t("about.metrics.partners")}</dt>
              </div>
              <div>
                <dd className="font-serif text-3xl text-[var(--tt-text)]">54</dd>
                <dt className="tt-overline mt-2">{t("about.metrics.countries")}</dt>
              </div>
            </dl>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
